/**
 * Configuración general de la aplicación
 * Colegio Bertolt Brecht - Ayacucho
 */

export const APP_CONFIG = {
    name: 'Colegio Bertolt Brecht',
    shortName: 'Bertolt Brecht',
    slogan: 'La mejor experiencia de aprendizaje',
    description: 'Comunidad educativa de excelencia que potencia integralmente a futuros ciudadanos',

    // Misión y Visión
    mission: 'Somos una comunidad educativa de excelencia que potencia integralmente a futuros ciudadanos para trascender de manera inclusiva e innovadora.',
    vision: 'Ser líderes educativos, comprometidos con la transformación de nuevas generaciones.',

    // Principio Ético
    ethicalPrinciple: 'Trata a los demás como te gustaría ser tratado.',

    // Información de contacto
    contact: {
        email: 'contacto@bertoltbrecht.edu.pe',
        phones: ['918 049 094', '956 452 679'],
        address: 'Jr. Callao N° 257',
        city: 'Ayacucho',
        country: 'Perú',
        fullAddress: 'Jr. Callao N° 257 - Ayacucho',
        mapUrl: 'https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d1265.854147185178!2d-74.22727356624655!3d-13.159983044154005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x91127df3a774ab1f%3A0xa8754afd6ff9a870!2sPlaza%20Mayor%20de%20Huamanga%2C%20Ayacucho!3m2!1d-13.1603789!2d-74.22578159999999!4m5!1s0x91127df240409b4f%3A0xb1ad2e99a506de15!2sRQRC%2B6RC%2C%20Jr.%20Callao%20257%2C%20Ayacucho%2005003!3m2!1d-13.1593944!2d-74.22811879999999!5e1!3m2!1ses!2spe!4v1764354819746!5m2!1ses!2spe',
    },

    // Redes sociales
    social: {
        facebook: 'https://facebook.com/bertoltbrechtayacucho',
        instagram: 'https://instagram.com/bertoltbrechtayacucho',
        youtube: 'https://youtube.com/@bertoltbrechtayacucho',
    },

    // Años de experiencia
    yearsOfExperience: 20,

    // Valores institucionales
    values: [
        {
            name: 'Liderazgo',
            description: 'Formamos líderes capaces de transformar su entorno'
        },
        {
            name: 'Participación',
            description: 'Fomentamos la participación activa en la comunidad'
        },
        {
            name: 'Solidaridad',
            description: 'Promovemos la ayuda mutua y el apoyo entre estudiantes'
        },
        {
            name: 'Responsabilidad',
            description: 'Cultivamos el compromiso con nuestras acciones'
        },
        {
            name: 'Disciplina',
            description: 'Desarrollamos hábitos de estudio y comportamiento'
        }
    ],
};
